import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Pager.scss';
import classNames from 'classnames';

import PagerButton from './PagerButton';

export default class Pager extends Component {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        pageCount: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        className: PropTypes.string,
    };

    render() {
        const {className} = this.props;
        const classes = classNames(styles.pager, className);

        return (
            <div className={classes}>
                <PagerButton label='First'
                             onClick={this.handleFirstPage}/>

                <PagerButton className={styles.backIcon}
                             onClick={this.handlePreviousPage}/>

                {this.getButtonPageIntervalList().map(this.renderPageButton)}

                <PagerButton className={styles.forwardIcon}
                             onClick={this.handleNextPage}/>

                <PagerButton label='Last'
                             onClick={this.handleLastPage}/>
            </div>
        );
    }

    getButtonPageIntervalList() {
        const {currentPage} = this.props;
        const start = this.clampPageNumber(currentPage - 2);
        const end = this.clampPageNumber(currentPage + 2);

        return _.range(start, end + 1);
    }

    clampPageNumber(pageNumber) {
        const {pageCount} = this.props;
        return _.clamp(pageNumber, 1, pageCount);
    }

    renderPageButton = (page, index) => {
        const {currentPage} = this.props;
        const selected = page === currentPage;

        return <PagerButton key={index}
                            label={page}
                            selected={selected}
                            onClick={this.handleSetPage(page)}/>;
    };

    handleFirstPage = () => {
        this.handleChangePage(1);
    };

    handlePreviousPage = () => {
        const {currentPage} = this.props;
        this.handleChangePage(currentPage - 1);
    };

    handleSetPage = page => () => {
        this.handleChangePage(page);
    };

    handleChangePage(nextCurrentPage) {
        const clampedNextCurrentPage = this.clampPageNumber(nextCurrentPage);
        this.props.onChange(clampedNextCurrentPage);
    }

    handleNextPage = () => {
        const {currentPage} = this.props;
        this.handleChangePage(currentPage + 1);
    };

    handleLastPage = () => {
        const {pageCount} = this.props;
        this.handleChangePage(pageCount);
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/Pager.jsx